import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { AuthTokenService } from '../services/auth-token.service';

export const authGuard: CanActivateFn = () => {
  const tokenStore = inject(AuthTokenService);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (tokenStore.getAccessToken()) {
    return true;
  }

  return authService.restoreSession().pipe(
    map((restored) => (restored ? true : router.parseUrl('/login'))),
    catchError(() => of(router.parseUrl('/login')))
  );
};

export const authChildGuard: CanActivateChildFn = (route, state) => authGuard(route, state);
